var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"settings-ems"},[_c('GeneralSettingsEMS',{attrs:{"showMpcBatteryPowerLimit":false,"showPlcControllingState":false,"device-data":_vm.mpcData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }